import GoalsModal from './container'
export default GoalsModal
